import React, { useEffect, useState } from 'react';
import './Table.css';
import {Link} from 'react-router-dom';
import Title from "./Title";

const Table_blogers = () => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const [seconds, setSeconds] = useState(120);

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 120));
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        fetch( global.config.api + '/?method=bloggers_feed')
            .then(response => response.json())
            .then(json => {
                if (json && json.feed) {
                    let bloggers = json.feed;
                    setData(bloggers);
                } else {
                    console.error('Invalid data structure', json);
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    let totalPages = Math.ceil(data.length / itemsPerPage);

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        if (totalPages <= 10) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            if (currentPage <= 5) {
                for (let i = 1; i <= 6; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push('...');
                pageNumbers.push(totalPages);
            } else if (currentPage >= totalPages - 4) {
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = totalPages - 5; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            } else {
                pageNumbers.push(1);
                pageNumbers.push('...');
                for (let i = currentPage - 2; i <= currentPage + 2; i++) {
                    pageNumbers.push(i);
                }
                pageNumbers.push('...');
                pageNumbers.push(totalPages);
            }
        }

        return pageNumbers.map(number => (
            <button
                key={number}
                onClick={() => number !== '...' && handlePageClick(number)}
                className={number === currentPage ? 'active' : ''}
            >
                {number}
            </button>
        ));
    };

    const getPriceChangeClass = (change) => {
        return change < 0 ? 'negative' : 'positive';
    };

    const getProcentChangeClass = (change) => {
        return change <= 0 ? 'red' : 'green';
    };

    const toOptionalFixed = (num, digits) =>
        `${Number.parseFloat(num.toFixed(digits))}`;

    const renderStars = (rating) => {
        const full_stars  = Math.floor( rating );
        const half_stars  = Math.ceil( rating - full_stars ) + full_stars;

        let all_stars = [];
        //console.error( full_stars + ' ' + half_stars + ' ' + empty_stars);
        for (let i = 1; i <= 5; i++) {
            if( full_stars >= i){
                all_stars[i] = 'full';
            } else if ( half_stars >= i ){
                all_stars[i] = 'half';
            } else {
                all_stars[i] = 'empty';
            }
        }
        let rating_float = parseFloat(rating) + 0.001 ;

        // rating.toFixed(1);
        return (<div className="star-rating"><span className="rating-text">{rating_float.toFixed(1)}</span>
            {all_stars.map(star => (
                <div className={'star star-' + star} aria-hidden="true"></div>
                ))}
            </div>
        );
    }

    const getPostThumbnail = (avatar) => {
        return avatar == '' ? require('../img/no_avatar.png') : avatar;
    }

    const formatTime = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes} мин ${seconds < 10 ? `0${seconds}` : seconds} сек`;
    };

    return (
        <div>
            <div className='container'>
                <div className='headline-txt'>
                    <h1>Курсы криптовалют</h1>
                    <p>Актуальные цены на криптовалюты.<br></br>
                        Обновление данных через <span>{formatTime(seconds)}</span></p>
                </div>
                <div className='table'>
                    <table>
                        <tbody>
                            {currentItems.map((item, index) => (
                                <tr key={index}>
                                    <td className='first-col'>
                                        <Link to={ item.slug }>
                                            <img src={getPostThumbnail(item.avatar)}></img>
                                            <span className='coin'>{item.name}</span>
                                        </Link>
                                    </td>
                                    <td>
                                        <div className='buy-btn'>
                                            {renderStars(item.stars_rating)}
                                        </div>
                                    </td>
                                    <td className='price'>
                                        <span>
                                            На рынке с {item.on_market_from}
                                        </span>
                                    </td>
                                    <td className='procent_change_col'>
                                        <span className={`procent_change ${getProcentChangeClass(item.comment_count)}`}>
                                            Отзывы ({item.comment_count})
                                        </span>
                                    </td>
                                    <td className='favorite_btn-col'><button className='favorite_btn'></button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="pagination">
                    <button className='prev' onClick={handlePrevPage} disabled={currentPage === 1}>

                    </button>
                    {renderPageNumbers()}
                    <button className='next' onClick={handleNextPage} disabled={currentPage === totalPages}>

                    </button>
                </div>
            </div>
        </div>
    );
};

export default Table_blogers;
